import { z } from 'zod';

import { VALIDATION_MESSAGES } from '@/constants/constant';

const baseSchema = z.object({
  title: z
    .string()
    .trim()
    .nonempty(VALIDATION_MESSAGES.createLesson.title.required)
    .min(2, VALIDATION_MESSAGES.createLesson.title.min)
    .max(100, VALIDATION_MESSAGES.createLesson.title.max),
  description: z
    .string()
    .trim()
    // .nonempty(VALIDATION_MESSAGES.createLesson.description.required)
    .optional(),
  classId: z
    .string()
    .nonempty(VALIDATION_MESSAGES.createLesson.classAssigned.required),
  dueDate: z
    .string()
    .nonempty(VALIDATION_MESSAGES.createLesson.dueDate.required),
  studentAssigned: z
    .array(z.string())
    .nonempty(VALIDATION_MESSAGES.createLesson.studentAssigned.required),
  teacherId: z.string().optional(),
  instructionsForStudents: z.string().trim().optional(),
});

// School module — requires teacherId
export const schoolCreateLessonSchema = baseSchema.extend({
  teacherId: z
    .string()
    .nonempty(VALIDATION_MESSAGES.createLesson.teacherAssigned.required),
});

// Teacher module — teacherId stays optional
export const teacherCreateLessonSchema = baseSchema;

// Single form type used by CreateLessonModal (teacherId optional)
export type TCreateLessonForm = z.infer<typeof baseSchema>;

// Backward-compat alias used by the old CreateLessonDrawer
export const createLessonFormSchema = schoolCreateLessonSchema;
